import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_2 = { class: "table table-tenant-sm table-hover" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = {
  key: 0,
  class: "badge text-bg-warning me-1"
}
const _hoisted_8 = {
  key: 1,
  class: "badge text-bg-secondary me-1"
}

import { ref, onMounted, computed } from "vue";
import AddCategory from "../components/shop/ShopCategory/AddCategory.vue";
import EditCategory from "../components/shop/ShopCategory/EditCategory.vue";
import EventsServices from "../services/EventsServices";
import notification from "@/core/plugins/notification";
import { LanguageTypes } from "@/core/types/LanguageTypes";

export default /*#__PURE__*/_defineComponent({
  __name: 'ShopCategory',
  setup(__props) {

const isLoading = ref(false);
const criteria = ref({
  status: null,
});

const data = ref<any>({});
const keys = computed(() => {
  return Object.keys(data.value);
});

const hasData = computed(() => {
  return data.value && Object.keys(data.value).length > 0;
});
const addCategoryRef = ref<InstanceType<typeof AddCategory> | null>(null);
const editCategoryRef = ref<InstanceType<typeof EditCategory> | null>(null);

const fecthData = async () => {
  isLoading.value = true;
  try {
    const response = await EventsServices.queryShopCategoryList(criteria.value);
    data.value = response;
    Object.values(data.value).forEach((item: any) => {
      item.changeStatusLoading = false;
    });
    console.log("fetched data:", data.value);
  } catch (error) {
    console.error("Error fetching data:", error);
  } finally {
    isLoading.value = false;
  }
};

const changeStatus = async (index: any, item: any) => {
  item.changeStatusLoading = true;
  try {
    await EventsServices.updateShopCategoryStatus(index);
    notification.success();
  } catch (error) {
    console.error("Error updating status:", error);
    notification.danger();
    item.status = !item.status; // Revert status change on error
  } finally {
    item.changeStatusLoading = false;
  }
};

const showAddCategory = () => {
  if (addCategoryRef.value) {
    addCategoryRef.value.show(keys.value);
  }
};

const showEditCategory = (key: any, languageData: any) => {
  if (editCategoryRef.value) {
    editCategoryRef.value.show(key, languageData);
  }
};

onMounted(() => {
  fecthData();
});

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_card, null, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", null, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("fields.status")), 1),
            _createVNode(_component_el_select, {
              modelValue: criteria.value.status,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((criteria.value.status) = $event)),
              placeholder: "Select Status",
              class: "w-150px ms-2",
              onChange: fecthData,
              disabled: isLoading.value
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList([null, true, false], (status) => {
                  return _createVNode(_component_el_option, {
                    key: status,
                    label: status === null ? 'All' : status ? 'Active' : 'Inactive',
                    value: status
                  }, null, 8, ["label", "value"])
                }), 64))
              ]),
              _: 1
            }, 8, ["modelValue", "disabled"])
          ]),
          _createVNode(_component_el_button, {
            type: "success",
            plain: "",
            onClick: showAddCategory,
            loading: isLoading.value,
            disabled: isLoading.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("action.add")), 1)
            ]),
            _: 1
          }, 8, ["loading", "disabled"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("table", _hoisted_2, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.status")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.key")), 1),
              _createElementVNode("th", _hoisted_3, _toDisplayString(_ctx.$t("fields.language")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("action.action")), 1)
            ])
          ]),
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_4, [
                _createVNode(_component_LoadingRing)
              ]))
            : (!isLoading.value && !hasData.value)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_5, [
                  _createVNode(_component_NoDataBox)
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", null, [
                        _createVNode(_component_el_switch, {
                          modelValue: item.status,
                          "onUpdate:modelValue": ($event: any) => ((item.status) = $event),
                          "active-color": "#67c23a",
                          "inactive-color": "#f56c6c",
                          loading: item.changeStatusLoading,
                          onClick: ($event: any) => (changeStatus(index, item))
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "loading", "onClick"])
                      ]),
                      _createElementVNode("td", null, _toDisplayString(index), 1),
                      _createElementVNode("td", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(LanguageTypes).all, (i, index) => {
                          return (_openBlock(), _createElementBlock("span", { key: index }, [
                            (Object.keys(item.data).includes(i.code))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(i.code), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(i.code), 1))
                          ]))
                        }), 128))
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_el_button, {
                          type: "warning",
                          plain: "",
                          onClick: ($event: any) => (showEditCategory(index, item.data)),
                          loading: isLoading.value,
                          disabled: isLoading.value
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("action.edit")), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick", "loading", "disabled"])
                      ])
                    ]))
                  }), 128))
                ]))
        ])
      ]),
      _: 1
    }),
    _createVNode(AddCategory, {
      ref_key: "addCategoryRef",
      ref: addCategoryRef,
      onSubmit: fecthData
    }, null, 512),
    _createVNode(EditCategory, {
      ref_key: "editCategoryRef",
      ref: editCategoryRef,
      onSubmit: fecthData
    }, null, 512)
  ], 64))
}
}

})